export default __webpack_public_path__ + "static/media/covidlogo.2f6c09f1.png";